
export const getPosition =()=>{
    return {
        lat: parseFloat(localStorage.getItem("lat")),
        lon: parseFloat(localStorage.getItem("lon")),
    }
}